import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
import { withPrefix } from 'gatsby'
import ArBaseIcon from '../ArBaseIcon/ArBaseIcon'

const StyledWrapper = styled.section`
  background-color: ${ ({ scBackgroundColor }) => scBackgroundColor } ;
  color: ${ ({ theme }) => theme.colors.white } ;
`

const StyledContainer = styled(ArBaseContainer)`
  position: relative;
  padding-bottom: 40px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 80px;
    padding-bottom: 80px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 100px;
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.18;
  margin: 0 auto;
  max-width: 900px;
  position: relative;
  text-align: center;
  ${ media.tablet`
    font-size: 4.5rem;
  ` }
`

const ImageLeft = styled(ArBaseImage)`
  position: absolute;
  bottom: -20px;
  left: 5px;
  width: 31%;
`

const ImageRight = styled(ArBaseImage)`
  position: absolute;
  top: -24px;
  right: 26px;
  width: 31%;
`

const StyledSocialList = styled.ul`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  > li {
    margin-left: 20px;
  }
`

class ArSocialSection extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    social: PropTypes.array,
    scBackgroundColor: PropTypes.string,
  }

  render () {
    const { title, social, backgroundColor } = this.props
    return (
      <StyledWrapper scBackgroundColor={backgroundColor}>
        <StyledContainer>
          <ImageLeft src={withPrefix('img/ArCTASection1.svg')} />
          <ImageRight src={withPrefix('img/ArCTASection2.svg')} />
          <StyledTitle>{ title }</StyledTitle>
          <StyledSocialList>
            {social.map(({ icon, link }) =>
              <li key={icon}>
                <a href={link} target="_blank" rel="noopener" aria-label={`${ icon.toUpperCase() } - Social Media Link`}>
                  <ArBaseIcon name={icon} size={30} />
                </a>
              </li>
            )}
          </StyledSocialList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArSocialSection
